export const Users = [
    {
        id:1,
        profilePicture: "person/1.jpg",
        username: "Danny Boy"
    },

    {
        id:2,
        profilePicture: "person/2.jpg",
        username: "Happiness Success "
    },

    {
        id:3,
        profilePicture: "person/3.jpg",
        username: "Success Jack  "
    },

    {
        id:4,
        profilePicture: "person/4.jpg",
        username: "Jack Daniel "
    },

    {
        id:5,
        profilePicture: "person/5.jpg",
        username: " Feeling Agu"
    },

    {
        id:6,
        profilePicture: "person/6.jpg",
        username: "Agu Faith"
    },

    {
        id:7,
        profilePicture: "person/7.jpg",
        username: "Faith Love"
    },

    {
        id:8,
        profilePicture: "person/8.jpg",
        username: "Love Peace "
    },

    {
        id:9,
        profilePicture: "person/9.jpg",
        username: "Power Sam "
    },

    {
        id:2,
        profilePicture: "person/2.jpg",
        username: "Peace Samuel "
    }
];


export const Posts = [
    {
        id:1,
        desc:"Love all,Hate None ",
        photo:"post/a.jpg",
        date:"5 min ago",
        userId:1,
        like:32,
        comment: 9
    },

    {
        id:2,
        desc:"Happiness Matters ",
        photo:"post/b.jpg",
        date:"15 min ago",
        userId:2,
        like:2,
        comment: 1
    },

    {
        id:3,
        desc:"Hate None ",
        photo:"post/c.jpg",
        date:"12 min ago",
        userId:3,
        like:3,
        comment: 1
    },

    {
        id:4,
        desc:"stay Happy ",
        photo:"post/d.jpg",
        date:"1 min ago",
        userId:4,
        like:35,
        comment: 5
    },

    {
        id:5,
        desc:"Just Breath ",
        photo:"post/e.jpg",
        date:"4 min ago",
        userId:5,
        like:4,
        comment: 1
    },

    {
        id:6,
        desc:"Happiness  is a good vibe",
        photo:"post/f.jpg",
        date:"1 min ago",
        userId:6,
        like:3,
        comment: 1
    },
    {
        id:7,
        desc:"Happiness  is a good vibe",
        photo:"post/f.jpg",
        date:"1 min ago",
        userId:6,
        like:3,
        comment: 1
    },
]